import React from "react";

const NearbyLocationCard = ({ name, distance, icon }) => {
  return (
    <div className="nearby-location-card">
      <img src={icon} alt={`${name}`} className="nearby-location-icon" />
      <h6 className="line-clamp line-clamp-2" title={name}>
        {name}
      </h6>
      <p>{distance} miles</p>
    </div>
  );
};

export default NearbyLocationCard;
